import React from 'react';
import {Redirect, Route, Switch} from "react-router-dom";

import Loader from './Loader';
import Home from '../routed/Home';
import PrivacyPolicy from '../routed/PrivacyPolicy';
import ProviderAcceptanceTerms from '../routed/ProviderAcceptanceTerms';
import Providers from '../providers/Providers';
import Provider from '../providers/Provider';
import Sitemap from '../routed/Sitemap';
import NotFound from '../routed/NotFound';
import Contact from '../routed/Contact';
import Maintenance from '../routed/Maintenance';
import ProviderApplication from '../routed/ProviderApplication';
import ConfirmProviderApplication from '../routed/ConfirmProviderApplication';
import AddProviderFeedback from '../providers/AddProviderFeedback';
import UnsubscribeFromProviderReports from '../providers/UnsubscribeFromProviderReports';

const RoutedComponents = () => {
    return <>{process.env.REACT_APP_MAINTENANCE_MODE === 'false' ?
        <Loader>
            <Switch>
                <Route exact path="/" component={Home} />
                <Route exact path="/providers-search" component={Providers} />
                <Route exact path="/provider/:providerID" component={Provider} />
                <Route exact path="/provider">
                    <Redirect to="/providers-search" />
                </Route>
                <Route exact path="/provider-application" component={ProviderApplication} />
                <Route exact path="/add-provider-feedback/:feedbackID" component={AddProviderFeedback} />
                <Route exact path="/add-provider-feedback">
                    <Redirect to="/" />
                </Route>
                <Route exact path="/provider-unsubscribing/:unsubscriptionID" component={UnsubscribeFromProviderReports} />
                <Route exact path="/provider-unsubscribing">
                    <Redirect to="/" />
                </Route>
                <Route exact path="/provider-unsubscribe/:unsubscriptionID" component={UnsubscribeFromProviderReports} />
                <Route exact path="/provider-unsubscribe">
                    <Redirect to="/" />
                </Route>
                <Route exact path="/confirm-provider-application/:applicationID" component={ConfirmProviderApplication} />
                <Route exact path="/confirm-provider-application">
                    <Redirect to="/" />
                </Route>
                <Route exact path="/contact-us" component={Contact} />
                <Route exact path="/provider-acceptance-terms" component={ProviderAcceptanceTerms} />
                <Route exact path="/privacy-policy" component={PrivacyPolicy} />
                <Route exact path="/sitemap" component={Sitemap} />
                <Route><NotFound navSecondaryShow={true} /></Route>
            </Switch>

        </Loader>
        :
        <Loader>
            <Switch>
                <Route exact path="/" component={Maintenance} />
                <Route path="/:any">
                    <Redirect to='/' />
                </Route>
            </Switch>
        </Loader>
    }</>
}

export default RoutedComponents;
